import { render, staticRenderFns } from "./VaFeed.vue?vue&type=template&id=3f3f2ddd&"
import script from "./VaFeed.vue?vue&type=script&lang=js&"
export * from "./VaFeed.vue?vue&type=script&lang=js&"
import style0 from "./VaFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports